(function () {
  'use strict';

  async function lcAddToCart(variantId, quantity, properties) {
    const qty = quantity || 1;
    const root = window.Shopify?.routes?.root || '/';
    const url = `${root}cart/add.js`;
    const item = { id: Number(variantId), quantity: Number(qty) || 1 };
    if (properties && typeof properties === 'object') {
      const clean = {};
      Object.keys(properties).forEach(function (key) {
        if (properties[key] != null && String(properties[key]).trim() !== '') {
          clean[key] = String(properties[key]);
        }
      });
      if (Object.keys(clean).length) item.properties = clean;
    }
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] }),
    });
    const data = await res.json().catch(function () {
      return {};
    });
    if (!res.ok) {
      throw new Error(data.description || data.message || 'Could not add to cart');
    }
    document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    return data;
  }

  window.lcAddToCart = lcAddToCart;

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('[data-lc-col-atc], [data-lc-buy-now][data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    const checkoutAfter = btn.hasAttribute('data-lc-buy-now');
    btn.disabled = true;
    try {
      await lcAddToCart(variantId, 1);
      if (
        document.body.classList.contains('lc-gift-upsell-active') ||
        document.body.dataset.lcGiftUpsellActive === '1' ||
        document.querySelector('[data-lc-gift-upsell-config]')
      ) {
        return;
      }
      if (checkoutAfter) {
        window.location.href = (window.Shopify?.routes?.root || '/') + 'checkout';
      }
    } catch (err) {
      window.alert(err.message || 'Could not add to cart.');
    } finally {
      btn.disabled = false;
    }
  });
})();
